/**
 * @author youngpan
 * 注册install
 */
import { Dialog } from 'element-ui'
export default class SildeFrame {
	static version = '__VERSION__1.0.0'

	/**
	 * Vue
	 */
	_Vue
	/**
	 * sildeFrame 的配置对象
	 * 侧边滑框的配置文件
	 * @type {Object}
	 */
	_frameOptions

	/**
	 * 高阶组件的存储hashMap
	 * @type {Object}
	 */
	_higterCompStoresMap = {}

	/**
	 * 组件实例集合
	 * @type {Array}
	 */
	_compCaseStores

	/**
	 * constructor for SildeFrame
	 * @constructs
	 * @param  {Object} [frameOptions={}] -全局的模块配置
	 * @param  {Vue} vue                  -Vue
	 */
	constructor(vue) {
		this._Vue = vue
		this._higterCompStoresMap = {}
		this._compCaseStores = []
	}

	/**
	 * 关闭已经打开的弹层
	 * @param  {string} compName [description]
	 */
	destoryComp(compName) {
		let module = this._compCaseStores.find((comp) => {
			return comp.$options.name === compName + 'Higher'
		})
		if (!module) {
			return console.error(`找不到组件 => ${compName}`)
		}
		module.$destroy(true)
	}

	/**
	 * 关闭当前所有打开的弹层
	 */
	destoryAll() {
		this._compCaseStores.forEach(comp => comp.$destroy(true))
	}

	/**
	 * 打开指定的模块
	 * @param  {string|Object}  moduleName     -模块名字、或者模块对象
	 * @param  {component}      parent         -父级组件
	 * @param  {Boolean}        [isRoot=false] -是否要放在全局
	 * @param  {Object}         [propsData={}] -propsData
	 */

	async open(moduleName, parent, isRoot = false, propsData = {}, el) {
		var moduleType = typeof moduleName
		if (moduleType !== 'string' && moduleType !== 'object' && moduleType !== 'function') {
			return console.error('打开侧滑框的第一个参数，只可以为配置好的模块名， 或者定义的模块对象')
		}
		// insert to Root or Part
		el = el || parent.$el
		if (isRoot) {
			parent = parent.$root
			el = document.getElementById('app')
		}

		if (!parent) {
			return
		}

		// 生成一个挂载元素，并且插入到想到的节点上
		el = this._createElAddAppend(el)

		// 如果父级是属于层级嵌套的, 要删除top, bottom, 避免层级嵌套的样式错位
		// 针对左边弹层方案

		// TODO 是否要兼容全局的所有弹层
		//
		//

		// 扩展所有的弹层, mask
		// get heiger layer component
		let HigerSlideComp = await this._getHigterComps(moduleName, moduleType, propsData).catch(console.error)
		/**
		 * 将挂载节点插入到当前的实例/或者全局实例的$el上
		 */
		let silderCase = new HigerSlideComp({
			parent,
			el,
			propsData
		})
		silderCase._isSilderLayer = true


		// 重写destory
		this._rewriteDestroy(silderCase)
		// 增加到实例数组
		this._addCaseStore(silderCase)

		// 返回实例
		return silderCase
	}


	/**
	 * 重写实例的destory方法
	 * @param  {object} silderCase -组件实例
	 */
	_rewriteDestroy(silderCase) {
		// 保存$destroy
		let _destroy = silderCase.$destroy
		let _this = this
		silderCase.$destroy = function (...arg) {
            if (this._hasDestory) {
                return false
            }
            this._hasDestory = true
			// 从实例数组中移除
			for(let i = 0, l = _this._compCaseStores.length; i < l; i++) {
				if (_this._compCaseStores[i].$options.name == this.$options.name) {
					_this._compCaseStores.splice(i, 1)
				}
			}
			//_this._compCaseStores.$remove(this)
			// 触发原有的destory方法
			_destroy.apply(this, arg)
            _destroy = null

			// 触发内存销毁机制
			_this._startClearMemory(this.$options.name)
		}
	}

	_compCaseWeakSet = new WeakSet()
	/**
	 * 增加到实例数组中
	 * @param {object} silderCase [description]
	 */
	_addCaseStore(silderCase) {
		// 将组件插进实例保存列表
		this._compCaseStores.push(silderCase)
		this._compCaseWeakSet.add(silderCase)
	}

    _closeCompChild(comp) {
        //
        lastForEach(this._compCaseStores, (compCase) => {
            // 要重最后遍历
            if (compCase && compCase.$parent === comp) {
                compCase.$destroy(true)
            }
        })
    }
	/**
	 * 增加一个div并且插入到parentEl, 作为子级元素
	 * @param  {element} parentEl -要插入的父级元素
	 * @return {element}          -新生成的元素
	 */
	_createElAddAppend(parentEl) {
        // 兼容点击按钮之后, 空格按钮和enter 会不断的生成遮罩,那是因为上一个按钮一致处于foucs
        document.activeElement && document.activeElement.blur()
		// 创建节点
		let el = document.createElement('div')
		// 插入节点
		parentEl.appendChild(el)

		return el
	}

	_compCutrMeakSet = new WeakSet()
	/**
	 * 获取生成的高阶组建
	 *
	 * 主要逻辑:
	 * 判断当前高阶组建的映射表有没有已经生成的，
	 * 如果有，  则将映射的高阶组建生成，
	 * 如果没有，则新生成一个高阶组件， 然后加入映射表中
	 *
	 *
	 *
	 * @param {string} moduleName 模块名
	 * @param {String} moduleType 模块类型
	 * @param {Object} options 配置参数
	 * @return {components}                -高阶组建
	 */
	async _getHigterComps(module, moduleType, options) {
        let moduleName = module.name
        let component = module
		// 停止删除内存
		this._stopClearMemory(moduleName)
		// try to find in _higterCompStoresMap
		let higterModule = this._higterCompStoresMap[moduleName]
		// had not Gennerate before
		if (!higterModule) {
            if (typeof component === 'function') {
                component = await this.getComp(component)
                component.name = moduleName
            }
			// 获取模块
            higterModule = this.silderGenerator(component, options)
			this._higterCompStoresMap[moduleName] = higterModule
			this._compCutrMeakSet.add(higterModule)
		}
		return higterModule
    }
    
    getComp(component) {
        return new Promise((res, rej) => {
            component(comp => {
                res(comp)
            })
        })
    }

	/**
	 * Vue.extend
	 * @param  {component} higerSlideComp -高阶组件
	 */
	_extend(higerSlideComp) {
		if (!higerSlideComp.name) {
			console.error('模块要定义名字')
			return false
		}
		higerSlideComp.name = higerSlideComp.name + 'Higher'
		// extend component
		return this._Vue.extend(higerSlideComp)
	}

	/**
	 * 高阶组建的构造器
	 * @param {component} comp -要转换的元素
	 * @param {Object} options 配置参数
	 * @return {component}      -构造后的高阶组件
	 */
	silderGenerator(compExc, options) {
		// 复制一份新的模块
		let {
			hotID,
			...comp
		} = compExc
		// 进行反编译
		comp = this._deCompile(comp)
		// 增加minxin
		this.addMinxin(comp)
		// extend 形成新的组件名字
		let higherComp = this._extend(comp)
		// 摧毁对象
		this._deCompile(comp)
		this.deleteObj(comp)

		return higherComp
	}

	/**
	 * 反编译组件
	 * @param  {component} comp -已经实例化的组件
	 */
	_deCompile(comp) {
		comp._Ctor && delete comp._Ctor
		comp._componentNameMap && delete comp._componentNameMap
		return comp
	}

	/**
	 * 混合
	 * @type {Object}
	 */
	_mixin
	/**
	 * 为一个组建增加一个混合
	 * @param  {component} comp 要加入的混合的组件
	 * @return {component}      -已加入混合的组件
	 */
	addMinxin(comp, _mixin) {
		if (!this._mixin) {
			let layerMixin = Dialog
			// 删除template
			delete layerMixin.template
			this._mixin = layerMixin
		}

		_mixin = _mixin || this._mixin
		// must be array
		comp.mixins = comp.mixins || []
		// try to find
		let hasMixin = comp.mixins.find(mixin => mixin === _mixin)
		// filter minxin
		if (!hasMixin) {
			comp.mixins.push(_mixin)
		}
		return comp
	}

	/**
	 * 管理内存, 对一个组件长时间不用, 要去删除其高阶组件的内存
	 *
	 * 在组件构造函数生成之后，在其实例的组建摧毁的时候，去清除其构造函数
	 *
	 * @return {[type]} [description]
	 */

	_timeOutId = {}
	_startClearMemory(name) {
		name = name.replace('Higher', '')
		// 清除单独
		this._stopClearMemory(name)
		this._timeOutId[name] = window.setTimeout(() => {
			delete this._timeOutId[name]

			let comp = this._higterCompStoresMap[name]
			delete this._higterCompStoresMap[name]

			this.disintegrateCompCutr(comp)
		}, 60000)
	}
	/**
	 * 关闭当前清除内存的定时器
	 * @param  {string} name [description]
	 */
	_stopClearMemory(name) {
		name = name.replace('Higher', '')
		window.clearTimeout(this._timeOutId[name])
		delete this._timeOutId[name]
	}

	/**
	 * 瓦解一个组件类，因为引用的复杂性和内存的释放不干净。
	 * @param  {Compontent} cutr -一个构造函数
	 */
	disintegrateCompCutr(cutr = {}) {
		if (cutr && cutr.options) {
			// 删除组件引用自身， 因为options.components 数组中也引用着 cutr
			this.deleteObj(cutr.options.components)
			// 摧毁组建的options对象
			this.deleteObj(cutr.options)
		}
		this.deleteObj(cutr.prototype)
		// 因为无法delete proptotype属性
		cutr.prototype = null

		// 删除内存
		this.deleteObj(cutr)
	}

	/**
	 * 碎片化一个对象的属性
	 * @param  {object}  obj          -要碎片的对象
	 * @param  {Boolean} [deep=false] -是否要深度碎片
	 */
	deleteObj(obj = {}, deep = false) {
		for (var key in obj) {
			if (obj[key] && typeof obj[key] === 'object' && deep === true) {
				this.deleteObj(obj[key], deep)
			}
			delete obj[key]
		}
		obj.prototype = null
		obj.constructor = null
	}
}



// WEBPACK FOOTER //
// ./src/plugins/layer/layer.js